import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useClientsContext } from '../context/ClientsContext';
import { generateQueryKey, QueryKeys, QueryType } from '../utils/generateQueryKey';
export const useAssistantPropertiesQuery = function (options) {
  var _options;
  if (options === void 0) {
    options = {};
  }
  const {
    assistantPropertiesClient
  } = useClientsContext();
  const {
    data: assistantProperties,
    ...rest
  } = useQuery({
    queryKey: generateQueryKey(QueryKeys.ASSISTANT_PROPERTIES, QueryType.GET),
    queryFn: () => assistantPropertiesClient.getProperties.call(assistantPropertiesClient),
    enabled: ((_options = options) == null ? void 0 : _options.enabled) ?? true
  });
  return {
    assistantProperties,
    ...rest
  };
};
export const useAssistantProperties = () => {
  const {
    assistantProperties
  } = useAssistantPropertiesQuery();
  if (!assistantProperties) {
    throw new Error('useAssistantProperties must be used within a <DataLoaderProvider />');
  }
  return {
    assistantProperties
  };
};
export const useAssistantPropertiesMutations = function (options) {
  if (options === void 0) {
    options = {};
  }
  const queryClient = useQueryClient();
  const {
    assistantPropertiesClient
  } = useClientsContext();
  const {
    assistantProperties,
    refetch: refetchAssistantProperties
  } = useAssistantPropertiesQuery(options);
  const {
    mutateAsync: updateAssistantProperties,
    isLoading: isMutating
  } = useMutation({
    mutationKey: generateQueryKey(QueryKeys.ASSISTANT_PROPERTIES, QueryType.UPDATE),
    mutationFn: propsToUpdate => assistantPropertiesClient.updateProperties.call(assistantPropertiesClient, {
      ...assistantProperties,
      ...propsToUpdate
    }),
    onSuccess: data => {
      queryClient.setQueryData(generateQueryKey(QueryKeys.ASSISTANT_PROPERTIES, QueryType.GET), data);
    }
  });
  const {
    mutateAsync: createAssistantProperties,
    isLoading: isCreateLoading
  } = useMutation({
    mutationKey: generateQueryKey(QueryKeys.ASSISTANT_PROPERTIES, QueryType.CREATE),
    mutationFn: params => assistantPropertiesClient.createProperties.call(assistantPropertiesClient, params),
    onSuccess: data => {
      queryClient.setQueryData(generateQueryKey(QueryKeys.ASSISTANT_PROPERTIES, QueryType.GET), data);
    }
  });
  return {
    updateAssistantProperties,
    refetchAssistantProperties,
    isMutating,
    createAssistantProperties,
    isCreateLoading
  };
};
//# sourceMappingURL=useAssistantProperties.js.map